import BaseCommand from "@/models/api/commands/BaseCommand";

export class AddAttributeCommand extends BaseCommand {
  CommandName = "AddAttribute";
  Command: { TmpId: string | null; AttributePrototypeId: number; Value: string };
  constructor(sessionId: string, operationId: string, tmpId: string | null, prototypeId: number, value: string) {
    super(sessionId, operationId);
    this.Command = { TmpId: tmpId, AttributePrototypeId: prototypeId, Value: value };
  }
}
